
const digest = '81245e4d58214bb342fa6da4128e86bf18607c4ffc13719474ee3564024c529a';
const css = `._content_bejpi_1 {
  width: 350px;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

._dialog_bejpi_9 {
  padding: 64px;
}

._connectButton_bejpi_13 {
  margin-bottom: 12px !important;
  width: 100%;
}

._title_bejpi_18 {
  margin-top: 15px !important;
  text-align: center;
}

@media only screen and (max-width: 540px) {
  ._content_bejpi_1 {
    width: 100%;
  }
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"content":"_content_bejpi_1","dialog":"_dialog_bejpi_9","connectButton":"_connectButton_bejpi_13","title":"_title_bejpi_18"};
export { css, digest };
  